<template>

    <m-edit1/>

    <m-section-204 v-bind='{...{"image":"https:\/\/api.mixitweb.com\/storage\/assets\/hero2.png"},...{}}' :style='""' class="" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row mx-auto justify-content-center" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-12 text-center " >
                <template #default>   <m-h1 v-bind='{...{},...{}}' :style='""' class="text-white " >
                <template #default> ما برای موفقیت شما برنامه داریم!   </template>
                </m-h1></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-12 text-center mb-4" >
                <template #default>   <m-p v-bind='{...{},...{}}' :style='""' class="text-white col-lg-8 col-md-12 mx-auto" >
                <template #default>انتخاب یک تیم حرفه‌ای برای طراحی وبسایت می‌تواند تفاوتی اساسی در مسیر موفقیت کسب‌وکار شما ایجاد کند. ما با سال‌ها تجربه در طراحی و توسعه وبسایت‌های موفق و متعهد به ارائه بهترین راهکارها، در کنار شما هستیم تا نیازهای شما را به دقت بشناسیم و راه‌حل‌هایی منحصربه‌فرد برایتان ارائه دهیم.

ما به تخصص و تجربه خود اطمینان داریم و این اطمینان را با ارائه مشاوره دقیق، شفاف و هدفمند به شما منتقل می‌کنیم. هر سوال، ابهام یا چالشی که داشته باشید، تیم ما آماده است تا پاسخ‌هایی کاربردی و حرفه‌ای ارائه دهد. اعتماد شما سرمایه ماست و این اعتماد را با تعهد به کیفیت، دقت در کار و پشتیبانی مداوم حفظ خواهیم کرد.

اجازه دهید تجربه ما، مسیر شما را هموارتر کند. برای دریافت مشاوره، همین امروز با ما تماس بگیرید!   </template>
                </m-p></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-12 text-center mb-5" >
                <template #default>   <m-form-step-1 v-bind='{...{"formId":null,"redirectDirectLink":""},...{}}' :style='""' class="bg-white py-5 rounded" ></m-form-step-1></template>
                </m-div></template>
                </m-div></template>
                </m-section-204>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mSection204 from '@moeinmdn/miw-alpha-components/src/package/Sections/Section204'; import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P'; import mFormStep1 from '@moeinmdn/miw-alpha-components/src/package/Form/FormStep/FormStep1/FormStep1';

export default {
    name: 'HomeView',
    components: {mEdit1, mSection204,mDiv,mH1,mP,mFormStep1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
